import { toast, Slide } from 'react-toastify'
const progressColor = typeOfNotification => {
  switch (typeOfNotification) {
    case 'error':
    case 'warning':
      return 'progressBarError'
    case 'info':
      return 'progressBarInfo'
    default:
      return 'azureBlue'
  }
}
const openNotificationWithMsg = (typeOfNotification, notificationMsg, onClose, className) => {
  const color = progressColor(typeOfNotification)
  toast.dark(notificationMsg, {
    position: 'top-right',
    autoClose: typeOfNotification === 'error' ? 20000 : 5000,
    onClose: onClose,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    className: className,
    progressClassName: `bg-${color}`,
    transition: Slide,
  })
}
const openErrorNotificationWithMsg = (...args) => openNotificationWithMsg('error', ...args)
export default openNotificationWithMsg
export { openErrorNotificationWithMsg }
